"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var module_1 = require("./module");
var interaction_1 = require("./interaction");
exports.ContinueButton = function (_a) {
    var _b = _a.children, children = _b === void 0 ? "Continue" : _b, _c = _a.onClick, onClick = _c === void 0 ? undefined : _c, _d = _a.align, align = _d === void 0 ? "center" : _d, other = __rest(_a, ["children", "onClick", "align"]);
    var _e = react_1.useContext(module_1.ModuleContext), _ = _e[0], dispatch = _e[1];
    var ti = react_1.useContext(interaction_1.InteractionContext);
    if (!onClick) {
        onClick = function () { return dispatch(module_1.goForward(ti.topic + ":" + ti.name)); };
    }
    return (react_1.default.createElement(creator_ui_1.Button, __assign({ alignSelf: align, onClick: onClick }, other), children));
};
exports.ContinueButton.displayName = "ContinueButton";
exports.ContinueButton.editableFields = [
    {
        name: "align",
        assign: function (block, value) {
            block.props.alignSelf = value;
        },
        type: "enum",
        defaultValue: ["center", "center"],
        values: [
            ["left", "flex-start"],
            ["center", "center"],
            ["right", "flex-end"]
        ],
        help: "Horizontal alignment of the button"
    },
    {
        name: "content",
        assign: function (block, value) {
            block.children = value;
        },
        defaultValue: "Continue",
        type: "text",
        help: "Button content; default is Continue"
    }
];
